import React from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const navigateToPage = (page) => {
    window.scrollTo(0, 0);
    navigate(page);
  };

  const openWhatsapp = () => {
    const phoneNumber = "+923008220544";
    const message = "Hello, I would like to get in touch with you!";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };
  return (
    <div className="footer-section">
      <Container>
        <Row>
          <Col md={3}>
            <div className="footer-txt">The Company</div>
            <div
              className="footer-sub-text"
              onClick={() => navigateToPage("/about")}
            >
              About Us
            </div>
            <div
              className="footer-sub-text"
              onClick={() => navigateToPage("/contact")}
            >
              Contact Us
            </div>
            <div
              className="footer-sub-text"
              onClick={() => navigateToPage("/catalog-listing")}
            >
              Catalogue
            </div>
            {/* <div
              className="footer-sub-text"
              onClick={() => navigateToPage("/blog")}
            >
              Blogs
            </div> */}
          </Col>
          <Col md={3}>
            <div className="footer-txt">Need Help</div>
            <div
              className="footer-sub-text"
              onClick={() => navigateToPage("/contact")}
            >
              Book an appointment
            </div>
            <div className="footer-sub-text" onClick={() => openWhatsapp()}>
              contact us
            </div>
          </Col>
          {/* <Col md={3}>
            <div className='footer-txt'>Newsletter</div>
            <div className='footer-sub-text'>    <Form>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>Email address</Form.Label>
                <Form.Control type="email" placeholder="Enter your email here" />
              </Form.Group>

            </Form></div>
          </Col> */}
          <Col md={3}>
            <div className="footer-txt">social links</div>
            <div>
              <div className="d-flex align-items-center gap-4">
                <div
                  className="social-icons"
                  onClick={() =>
                    window.open(
                      "https://www.instagram.com/naqshzari.pk/?hl=en",
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                >
                  <svg
                    width="21"
                    height="22"
                    viewBox="0 0 21 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.4325 2.85163C13.1626 2.85163 13.5348 2.85163 14.6517 2.85163C15.6444 2.85163 16.1408 3.09981 16.5131 3.2239C17.0094 3.47209 17.3817 3.59618 17.754 3.96846C18.1263 4.34074 18.3745 4.71302 18.4985 5.20939C18.6226 5.58167 18.7467 6.07804 18.8708 7.07078C18.8708 8.18762 18.8708 8.4358 18.8708 11.2899C18.8708 14.1441 18.8708 14.3923 18.8708 15.5091C18.8708 16.5018 18.6226 16.9982 18.4985 17.3705C18.2504 17.8669 18.1263 18.2391 17.754 18.6114C17.3817 18.9837 17.0094 19.2319 16.5131 19.356C16.1408 19.4801 15.6444 19.6042 14.6517 19.7282C13.5348 19.7282 13.2866 19.7282 10.4325 19.7282C7.57838 19.7282 7.33019 19.7282 6.21336 19.7282C5.22062 19.7282 4.72425 19.4801 4.35197 19.356C3.8556 19.1078 3.48332 18.9837 3.11104 18.6114C2.73876 18.2391 2.49058 17.8669 2.36648 17.3705C2.24239 16.9982 2.1183 16.5018 1.9942 15.5091C1.9942 14.3923 1.9942 14.1441 1.9942 11.2899C1.9942 8.4358 1.9942 8.18762 1.9942 7.07078C1.9942 6.07804 2.24239 5.58167 2.36648 5.20939C2.61467 4.71302 2.73876 4.34074 3.11104 3.96846C3.48332 3.59618 3.8556 3.348 4.35197 3.2239C4.72425 3.09981 5.22062 2.97572 6.21336 2.85163C7.33019 2.85163 7.70247 2.85163 10.4325 2.85163ZM10.4325 0.990234C7.57838 0.990234 7.33019 0.990234 6.21336 0.990234C5.09652 0.990234 4.35197 1.23842 3.7315 1.48661C3.11104 1.73479 2.49058 2.10707 1.87011 2.72753C1.24965 3.348 1.00146 3.84437 0.629184 4.58893C0.380999 5.20939 0.256905 5.95395 0.132812 7.07078C0.132812 8.18762 0.132812 8.55989 0.132812 11.2899C0.132812 14.1441 0.132812 14.3923 0.132812 15.5091C0.132812 16.6259 0.380999 17.3705 0.629184 17.9909C0.87737 18.6114 1.24965 19.2319 1.87011 19.8523C2.49058 20.4728 2.98695 20.721 3.7315 21.0933C4.35197 21.3415 5.09652 21.4655 6.21336 21.5896C7.33019 21.5896 7.70247 21.5896 10.4325 21.5896C13.1626 21.5896 13.5348 21.5896 14.6517 21.5896C15.7685 21.5896 16.5131 21.3415 17.1335 21.0933C17.754 20.8451 18.3745 20.4728 18.9949 19.8523C19.6154 19.2319 19.8636 18.7355 20.2358 17.9909C20.484 17.3705 20.6081 16.6259 20.7322 15.5091C20.7322 14.3923 20.7322 14.02 20.7322 11.2899C20.7322 8.55989 20.7322 8.18762 20.7322 7.07078C20.7322 5.95395 20.484 5.20939 20.2358 4.58893C19.9877 3.96846 19.6154 3.348 18.9949 2.72753C18.3745 2.10707 17.8781 1.85888 17.1335 1.48661C16.5131 1.23842 15.7685 1.11433 14.6517 0.990234C13.5348 0.990234 13.2866 0.990234 10.4325 0.990234Z"
                      fill="white"
                    />
                    <path
                      d="M10.4325 5.95395C7.45429 5.95395 5.09652 8.31171 5.09652 11.2899C5.09652 14.2682 7.45429 16.6259 10.4325 16.6259C13.4107 16.6259 15.7685 14.2682 15.7685 11.2899C15.7685 8.31171 13.4107 5.95395 10.4325 5.95395ZM10.4325 14.7645C8.57112 14.7645 6.95792 13.2754 6.95792 11.2899C6.95792 9.42854 8.44703 7.81534 10.4325 7.81534C12.2939 7.81534 13.9071 9.30445 13.9071 11.2899C13.9071 13.1513 12.2939 14.7645 10.4325 14.7645Z"
                      fill="white"
                    />
                    <path
                      d="M15.8926 7.07078C16.5779 7.07078 17.1335 6.5152 17.1335 5.82985C17.1335 5.14451 16.5779 4.58893 15.8926 4.58893C15.2073 4.58893 14.6517 5.14451 14.6517 5.82985C14.6517 6.5152 15.2073 7.07078 15.8926 7.07078Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div
                  className="social-icons"
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/profile.php?id=61570379171723",
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                >
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.4636 11.2904C21.4636 5.62638 16.8294 0.992188 11.1654 0.992188C5.50138 0.992188 0.867188 5.62638 0.867188 11.2904C0.867188 16.4395 4.60028 20.6875 9.49193 21.4599V14.2511H6.91738V11.2904H9.49193V8.97329C9.49193 6.39874 11.0367 4.98274 13.3538 4.98274C14.5123 4.98274 15.6708 5.24019 15.6708 5.24019V7.81474H14.3836C13.0963 7.81474 12.7101 8.58711 12.7101 9.35947V11.2904H15.5421L15.0272 14.2511H12.5814V21.5886C17.7305 20.8162 21.4636 16.4395 21.4636 11.2904Z"
                      fill="white"
                    />
                  </svg>
                </div>
                {/* <div className="social-icons">
                  <svg
                    width="22"
                    height="15"
                    viewBox="0 0 22 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.6752 2.2704C20.4178 1.36931 19.7742 0.725669 18.8731 0.468214C17.3283 0.0820315 10.7632 0.0820312 10.7632 0.0820312C10.7632 0.0820312 4.32685 0.0820315 2.6534 0.468214C1.75231 0.725669 1.10866 1.36931 0.851201 2.2704C0.593746 3.94386 0.59375 7.29077 0.59375 7.29077C0.59375 7.29077 0.593754 10.6377 0.979936 12.3111C1.23739 13.2122 1.88102 13.8559 2.78211 14.1133C4.32684 14.4995 10.8919 14.4995 10.8919 14.4995C10.8919 14.4995 17.3283 14.4995 19.0018 14.1133C19.9029 13.8559 20.5465 13.2122 20.804 12.3111C21.1902 10.6377 21.1901 7.29077 21.1901 7.29077C21.1901 7.29077 21.1902 3.94386 20.6752 2.2704ZM8.8323 10.3802V4.20131L14.2389 7.29077L8.8323 10.3802Z"
                      fill="white"
                    />
                  </svg>
                </div> */}
              </div>
            </div>
          </Col>
        </Row>
        <div className="bottom-bar">
          <Row>
            <Col md={4}>
              <hr />
            </Col>
            <Col md={4}>
              <div className="copyright-text">
                © Naqshzari. all rights reserved.
              </div>
            </Col>
            <Col md={4}>
              <hr />
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default Footer;
